export default __webpack_public_path__ + "static/media/premium-icon-check-mark-4225683.f60090ca.png";